export const CREATE_DEBIT_NOTE_BILL_BASE  = 'CREATE_DEBIT_NOTE_BILL_BASE';
export const GET_DEBIT_NOTE_BILL_BASES  = 'GET_DEBIT_NOTE_BILL_BASES';
export const GET_DEBIT_NOTES_BILL_BASES_PAGE  = 'GET_DEBIT_NOTES_BILL_BASES_PAGE';
export const DEBIT_NOTE_BILL_BASE_REQUEST  = 'DEBIT_NOTE_BILL_BASE_REQUEST';
export const DELETE_DEBIT_NOTE_BILL_BASE  = 'DELETE_DEBIT_NOTE_BILL_BASE';
export const UPDATE_DEBIT_NOTE_BILL_BASE  = 'UPDATE_DEBIT_NOTE_BILL_BASE';
export const DEBIT_NOTE_BILL_BASE_REQUEST_SUCCESS  = 'DEBIT_NOTE_BILL_BASE_REQUEST_SUCCESS';
export const DEBIT_NOTE_BILL_BASE_REQUEST_FAILURE  = 'DEBIT_NOTE_BILL_BASE_REQUEST_FAILURE';